import { render, staticRenderFns } from "./discount-details.vue?vue&type=template&id=6c15f06e&scoped=true"
import script from "./discount-details.ts?vue&type=script&lang=ts&external"
export * from "./discount-details.ts?vue&type=script&lang=ts&external"
import style0 from "./discount-details.scss?vue&type=style&index=0&id=6c15f06e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c15f06e",
  null
  
)

export default component.exports